import React from "react";
import { LocaleLink } from "../../i18n/LocaleLink";
import { blogDetailsPath, getBlogs, getBlogTags } from "../../data/blogs";
import { useTranslation } from "react-i18next";

export const BlogPageSidebar = () => {
  const { t } = useTranslation();
  const blogs = getBlogs(t);
  const tags = getBlogTags(t);

  return (
    <aside className="blog-sidebar">
      {/* search */}
      {/* <div className="sidebar-search">
        <form action="#">
          <input type="text" placeholder="Search Here . . ." />
          <button type="submit">
            <i className="flaticon-search"></i>
          </button>
        </form>
      </div> */}

      {/* Categories */}
      <div className="blog-widget">
        <h4 className="bw-title">{t("blogSidebar.categories")}</h4>

        <div className="bs-cat-list">
          <ul className="list-wrap">
            {Array.from(new Set(blogs.map((blog) => blog.category))).map((category, idx) => (
              <li key={idx}>
                <a href="#">
                  {category}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* recents */}
      <div className="blog-widget">
        <h4 className="bw-title">{t("blogSidebar.recentPosts")}</h4>

        <div className="rc-post-wrap">
          {blogs.map((blog) => {
            const detailsTo = blogDetailsPath(blog.id);
            return (
            <div key={blog.id} className="rc-post-item">
              <div className="thumb">
                <LocaleLink to={detailsTo}>
                  <img src={blog.src} alt="" />
                </LocaleLink>
              </div>
              <div className="content">
                <span className="date">
                  <i className="far fa-calendar"></i>
                  {blog.createdAt}
                </span>
                <h2 className="title">
                  <LocaleLink to={detailsTo}>{blog.title}</LocaleLink>
                </h2>
              </div>
            </div>
            );
          })}
        </div>
      </div>

      {/* tags */}
      <div className="blog-widget">
        <h4 className="bw-title">{t("blogSidebar.tags")}</h4>

        <div className="bs-tag-list">
          <ul className="list-wrap">
            {tags.map((item) => (
              <li key={item.id}>
                <a href={item.href}>{item.title}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  );
};
